import React from 'react'
import { get } from 'lodash'
import { ALL_HTML_COMPONENTS, ALL_SVG_COMPONENTS, REMOTE_PORTAL_COMP_NAME } from './consts'
import { createController as ruiCreateController } from '@remote-ui/react/host'
import processProps from './processProps'
import { RemotePortal } from './createPortal'

type Options = {
	components?: Record<string, React.ComponentType<any>>
	allowHtml?: boolean
}

const buildHtmlComps = () => {
	const htmlComponents = [...ALL_HTML_COMPONENTS, ...ALL_SVG_COMPONENTS].reduce<Record<string, React.ComponentType>>(
		(acc, tagName) => {
			acc[tagName] = ({ children, ...props }) => {
				return React.createElement(tagName, processProps(props), children)
			}

			return acc
		},
		{}
	)

	const OptionComponent: React.ComponentType = ({ children, ...props }) => {
		const text = get(children, [0, 'props', 'text', 'text'])
		const fixedChildren = typeof text === 'undefined' ? children : text

		return React.createElement('option', processProps(props), fixedChildren)
	}

	return {
		...htmlComponents,
		option: OptionComponent,
	}
}

const createController = ({ components, allowHtml }: Options) => {
	return ruiCreateController({
		...components,
		...(allowHtml ? buildHtmlComps() : {}),
		[REMOTE_PORTAL_COMP_NAME]: RemotePortal,
	})
}

export default createController
